import { PersonType } from './person-type.model';
export class Unit {
    name:string;
    pax:number = 0;
    amount:number;
    personType:PersonType;

    
    constructor(personType:PersonType){
        this.name = personType.name.toUpperCase();
        this.personType = personType;
    }
}